export const CONDITIONAL_FORMATTING_FONT_FAMILIES = [
    'Aptos',
    'Courier New',
    'Lucida Handwriting',
    'Britannic',
    'Comic Sans MS',
    'MS Gothic',
] as const;

export type ConditionalFormattingFontFamily = (typeof CONDITIONAL_FORMATTING_FONT_FAMILIES)[number];
